<div class="date-picker-tab" cdkDropList (cdkDropListDropped)="onProfileDrop($event)">
  @for (profile of datePickerProfiles.controls; track profile; let i = $index) {
    <multi-shipment-date-picker-profile
      cdkDrag
      [formGroup]="profile"
      [sectionId]="'multi-shipment-date-picker-profile-' + i"
      (remove)="removeProfile(i)">
      <pdq-drag-and-drop
        dragHandle
        cdkDragHandle
        spacing="tight"
        (click)="$event.stopPropagation()"></pdq-drag-and-drop>
    </multi-shipment-date-picker-profile>
  }

  <pdq-button [plain]="true" icon="Plus" label="Add profile" (onClick)="addProfile()"></pdq-button>
</div>
